import * as service from './services'
import to from 'await-to-js'

export const state = {
  cartao: null
}

export const getters = {
  cartao: state => state.cartao
}

export const mutations = {
  setCartao (state, payload) {
    state.cartao = payload
  }
}

export const actions = {
  setCartao ({commit}, payload) {
    commit('setCartao', payload)
  },

  async validaCartaoSinsaude ({dispatch}, payload) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.validaSinSaude(payload))

    dispatch('setLoading', false)

    if (error) {
      dispatch('showErrorMsg', error)
      return Promise.reject(error)
    }

    dispatch('setCartao', response.data)

    return response.data
  },

  async salvaCartaoSinsaude ({dispatch}, payload) {
    dispatch('setLoading', true)
    const [error, response = {data: null}] = await to(service.salvarUsuarioSinSaude(payload))
    dispatch('setLoading', false)

    if (error) {
      dispatch('showErrorMsg', error)
      return Promise.reject(error)
    }
    dispatch('setCartao')
    return response.data
  }
}



// WEBPACK FOOTER //
// ./src/store/sinsaude/index.js